import { Link } from 'react-router-dom';

interface ArticleHeaderProps {
  imageUrl: string;
  imageAlt: string;
  title: string;
  updatedDate: string;
  readTime: string;
  tag: string;
}

export default function ArticleHeader({ imageUrl, imageAlt, title, updatedDate, readTime, tag }: ArticleHeaderProps) {
  return (
    <header className="relative w-full h-[420px] md:h-[520px] flex items-end overflow-hidden">
      <img
        src={imageUrl}
        alt={imageAlt}
        title={title}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/25"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 pb-10 md:pb-14">
        <Link
          to="/"
          className="inline-flex items-center text-white/70 text-sm hover:text-white mb-4 transition-colors duration-200"
        >
          <i className="ri-arrow-left-line mr-1.5"></i>
          Back to Home
        </Link>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          {title}
        </h1>
        <div className="flex items-center gap-4 mt-4 text-white/60 text-sm flex-wrap">
          <span className="px-2.5 py-1 rounded-full bg-white/15 text-white/80 text-xs font-medium">{tag}</span>
          <span>Updated: {updatedDate}</span>
          <span>·</span>
          <span>{readTime}</span>
        </div>
      </div>
    </header>
  );
}